











































































import {
  InteractionModel,
  CustomerBillingModel,
  VForm,
} from '@/app/shared/models';
import { refsService } from '@/app/shared/refs.service';
import { Component, Ref, Vue, Prop } from 'vue-property-decorator';
import { NotifyType } from '@/app/shared/enums/notify/notify-type.enum';
@Component
export default class DialogConfirmBlacklistComponent extends Vue {
  @Ref() private form!: VForm;
  @Prop(Object) readonly data!: { Value: string; MessageType: NotifyType };

  private dialog = false;

  private get refs() {
    return refsService;
  }
  private get rules() {
    return this.refs.static.rules;
  }
  private get customer(): CustomerBillingModel {
    return this.refs.modules.contract.customer;
  }
  private translateValue(text: string) {
    return this.$t(text)
      .toString()
      .replace('{value}', this.data.Value);
  }
  public async removeBlacklist() {
    const data = {
      Address: this.data.Value,
      MessageType: this.data.MessageType,
    };
    await this.refs.modules.notify.RemoveBlacklist(data).then(() => {
      this.refs.modules.ticket.createInteraction(
        new InteractionModel(
          this.$t('action_code.ac1'),
          this.$t('action_desc.ad57') +
            ' - ' +
            this.data.Value +
            '(' +
            this.refs.static.enumDescriptions.get2(
              this.refs.enums.NotifyType,
              data.MessageType
            ) +
            ')'
        )
      );
      this.$toast(this.$t('toasts.blacklist_removed_successfully'));
    });
    this.$bus.$emit('closeDialogBlacklist');
    this.dialog = false;
  }
}
